import {
  AreaUnit,
  BuildingType,
  HvacArea,
  ProjectData,
  ProjectStatus,
} from '@belimo-retrofit-portal/logic';
import { replace } from 'redux-first-history';
import { SagaIterator } from 'redux-saga';
import { createProject } from 'src/modules/common/sagas/utils/createProject';
import { resolveInitialProjectData } from 'src/modules/common/sagas/utils/resolveProjectData';
import { getLoggedInUser } from 'src/modules/login/selectors/getLoggedInUser';
import { loadProjectListFull } from 'src/modules/project-list/sagas/utils/loadProjectListFull';
import {
  PROJECT_CURRENCY_DEFAULT_DATA, PROJECT_EVALUATION_DEFAULT_DATA,
  PROJECT_HVAC_DEFAULT_DATA,
  PROJECT_PARTICIPANTS_DEFAULT_DATA, PROJECT_REPORT_DEFAULT_DATA,
  PROJECT_VERSION,
} from 'src/modules/project-new/constants/projectData';
import { logDebug } from 'src/sagas/utils/logging';
import { call, cancel, put, select } from 'typed-redux-saga';

export function* guest(): SagaIterator<void> {
  const projects = yield* call(loadProjectListFull);
  if (projects.length === 0) {
    yield* call(logDebug, 'Creating demo project...');
    const user = yield* select(getLoggedInUser);
    const data: ProjectData = {
      version: PROJECT_VERSION,
      title: 'Demo',
      goals: '',
      status: ProjectStatus.ACTIVE,
      statusComment: '',
      cover: null,
      building: {
        type: BuildingType.OFFICE,
        address: {
          country: 'CHE',
          city: '',
          street: '',
          zip: '',
          state: '',
        },
        size: null,
        unit: AreaUnit.SQM,
      },
      participants: {
        ...PROJECT_PARTICIPANTS_DEFAULT_DATA,
        author: `${user.firstName} ${user.lastName}`,
      },
      hvac: {
        ...PROJECT_HVAC_DEFAULT_DATA,
        areas: {
          [HvacArea.HEATING]: {
            ...PROJECT_HVAC_DEFAULT_DATA.areas[HvacArea.HEATING],
            enabled: true,
          },
          [HvacArea.COOLING]: {
            ...PROJECT_HVAC_DEFAULT_DATA.areas[HvacArea.COOLING],
            enabled: true,
          },
          [HvacArea.VENTILATION]: {
            ...PROJECT_HVAC_DEFAULT_DATA.areas[HvacArea.VENTILATION],
            enabled: true,
          },
        },
      },
      currency: PROJECT_CURRENCY_DEFAULT_DATA,
      report: PROJECT_REPORT_DEFAULT_DATA,
      evaluation: PROJECT_EVALUATION_DEFAULT_DATA,
    };

    const projectData = yield* call(resolveInitialProjectData, data);

    const project = yield* call(createProject, projectData);
    yield* put(replace(`/project/${encodeURIComponent(project.id)}`));
    yield* cancel();
  } else {
    yield* call(logDebug, 'Redirecting to first project...');
    const [project] = projects;
    yield* put(replace(`/project/${encodeURIComponent(project.id)}`));
    yield* cancel();
  }
}
